function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "ic-m-left_svg__a",
  d: "M.701 8.007a.73.73 0 01.233-.537L8.005.399c.707-.708 1.768.353 1.06 1.06L3.276 7.25H17a.75.75 0 110 1.5H3.262l5.804 5.804c.707.707-.354 1.768-1.06 1.06L.933 8.545A.73.73 0 01.7 8.008z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-3-4h24v24H-3z"
}), React.createElement("mask", {
  id: "ic-m-left_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#ic-m-left_svg__a"
})), React.createElement("g", {
  fill: "#191919",
  mask: "url(#ic-m-left_svg__b)"
}, React.createElement("path", {
  d: "M-41-42H59V58H-41z"
})));

var SvgIcMLeft = function SvgIcMLeft(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 16",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/ic-m-left.6e819fa0.svg";
export { SvgIcMLeft as ReactComponent };